import { t } from '@trimble/i18n';
import type { TreeNodeDefinition } from '@trimble/ui-components/solidjs';

import { isExtractedFeatureTreeNodeKind } from './fx-workspace-tree-nodes';
import type { FxWorkspaceTreeItem } from './fx-workspace-tree.types';
import { filterProjectDataNodes } from './project-data-filtering';

export type FxReferencesFilterMode = 'all' | 'active' | 'workspace';

export const FX_REFERENCES_FILTER_OPTIONS: () => Array<{
  key: FxReferencesFilterMode;
  label: string;
}> = () => [
  {
    key: 'all',
    label: t('mobileMapping.fxWorkspace.references.filter.allData'),
  },
  {
    key: 'active',
    label: t('mobileMapping.fxWorkspace.references.filter.activeData'),
  },
  {
    key: 'workspace',
    label: t('mobileMapping.fxWorkspace.references.filter.workspaceData'),
  },
];

export function isReferencesTreeNodeKind(
  kind: FxWorkspaceTreeItem['kind'] | undefined
): boolean {
  return (
    kind === 'references' ||
    kind === 'referenceCategory' ||
    kind === 'referenceMission' ||
    kind === 'referenceRuns' ||
    kind === 'referenceFolder' ||
    kind === 'reference'
  );
}

export function applyFxReferencesFilter(
  nodes: TreeNodeDefinition<FxWorkspaceTreeItem>[],
  filterMode: FxReferencesFilterMode,
  isMatch: (node: TreeNodeDefinition<FxWorkspaceTreeItem>) => boolean
): TreeNodeDefinition<FxWorkspaceTreeItem>[] {
  if (filterMode === 'all') {
    return nodes;
  }

  const extracted = nodes.filter((node) =>
    isExtractedFeatureTreeNodeKind(node.data?.kind)
  );
  const references = nodes.filter((node) =>
    isReferencesTreeNodeKind(node.data?.kind)
  );
  const referencesFolder = references.find(
    (node) => node.data?.kind === 'references'
  );
  const filteredReferences = filterProjectDataNodes(
    references,
    'active',
    '',
    isMatch
  ).nodes;

  if (
    referencesFolder !== undefined &&
    !filteredReferences.some((node) => node.id === referencesFolder.id)
  ) {
    return [...extracted, referencesFolder, ...filteredReferences];
  }

  return [...extracted, ...filteredReferences];
}
